import { z } from 'zod';
import { MAX_NAME_LENGTH, MAX_PHONE_LENGTH } from './constants';
import {
  publicMarketplaceRequiredPhoneSchema,
  sanitizePublicMarketplaceString,
} from './publicMarketplaceValidationPrimitives';

export { publicMarketplaceEmailSchema as emailSchema } from './publicMarketplaceValidationPrimitives';

export const unitTypeSchema = z.enum([
  'apartment',
  'house',
  'studio',
  'duplex',
  'triplex',
  'penthouse',
  'townhouse_unit',
  'office',
  'retail_local',
  'warehouse_unit',
  'coworking_space',
  'lot',
  'industrial_lot',
  'agricultural_parcel',
  'hotel_room',
  'suite',
  'condo_hotel_unit',
  'garage',
  'garage_with_storage',
  'storage_unit',
  'other',
]);

export const realEstateUnitTypologySchema = z.enum([
  'apartment',
  'flat',
  'studio',
  'duplex',
  'triplex',
  'penthouse',
  'loft',
]);

export const realEstateUnitAmenityKeySchema = z.enum([
  'luxury_finishes',
  'furnished',
  'dirt_road_access',
  'paved_road_access',
  'guard_booth',
  'nearby_malls',
  'electric_fence',
  'masonry_wall',
  'living_fence',
  'fireplace',
  'closet',
  'kitchen',
  'fitted_kitchen',
  'service_room',
  'duplex',
  'condominium',
  'nearby_schools',
  'oceanfront_first_row',
  'parkfront',
  'intercom',
  'jacuzzi',
  'garden',
  'nearby_parks',
  'pet_friendly',
  'pool',
  'reception',
  'security',
  'terrace',
  'triplex',
  'city_view',
  'ocean_view',
  'park_view',
  'walk_in_closet',
  'industrial_zone',
  'bbq_area',
  'air_conditioning',
  'laundry_area',
  'green_areas',
  'sports_courts',
  'access_control',
  'gym',
  'private_security',
  'white_goods',
  'grill',
  'lighting',
  'living_dining_room',
  'kids_playroom',
  'cleaning_service',
  'basic_services',
  'security_alarm',
  'commercial_use',
  'professional_use',
  'video_surveillance',
  'club_house',
  'guest_parking',
  'daily_dining_room',
  'sewer',
  'primary_bedroom_with_bathroom',
  'equipped',
  'entrance_hall',
  'independent_entrance',
  'internal_park',
  'patio',
  'communal_room',
  'entertainment_room',
  'sitting_room',
  'sauna',
  'solarium',
  'steam_room',
]);

export const updateBuyerPublicProfileSchema = z
  .object({
    firstName: z
      .string()
      .min(1, 'First name is required')
      .max(MAX_NAME_LENGTH)
      .transform(sanitizePublicMarketplaceString)
      .nullable()
      .optional(),
    lastName: z
      .string()
      .min(1, 'Last name is required')
      .max(MAX_NAME_LENGTH)
      .transform(sanitizePublicMarketplaceString)
      .nullable()
      .optional(),
    phone: z
      .string()
      .max(MAX_PHONE_LENGTH)
      .pipe(publicMarketplaceRequiredPhoneSchema)
      .nullable()
      .optional(),
  })
  .strict();

const PUBLIC_ATTRIBUTION_VALUE_MAX_LENGTH = 256;
const PUBLIC_ATTRIBUTION_PATH_MAX_LENGTH = 2048;
const publicAttributionTextSchema = z
  .string()
  .trim()
  .max(PUBLIC_ATTRIBUTION_VALUE_MAX_LENGTH)
  .transform(sanitizePublicMarketplaceString)
  .pipe(z.string().min(1));
export const marketplaceInquiryAttributionSchema = z
  .object({
    landingPath: z
      .string()
      .max(PUBLIC_ATTRIBUTION_PATH_MAX_LENGTH)
      .regex(/^\/(?!\/)[^?#\s]*$/u),
    utmSource: publicAttributionTextSchema.optional(),
    utmMedium: publicAttributionTextSchema.optional(),
    utmCampaign: publicAttributionTextSchema.optional(),
    utmTerm: publicAttributionTextSchema.optional(),
    utmContent: publicAttributionTextSchema.optional(),
  })
  .strict();
